import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// تكوين Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAsLe_NAQ49H3z7RqWvOZsXhgqOZJXxQl4",
  authDomain: "el-samy.firebaseapp.com",
  databaseURL: "https://el-samy-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "el-samy",
  storageBucket: "el-samy.appspot.com",
  messagingSenderId: "37176881927",
  appId: "1:37176881927:web:37012e002967bb3fa44ba2",
  measurementId: "G-9N2QSH9EHH"
};


// تهيئة Firebase
const app = initializeApp(firebaseConfig);

// تصدير الخدمات
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
